import { IpgSystemIdToName, type IpgSystemId } from '../third-party-system.enums';
import { CardPointeIpgSystemId } from './cardpointe/cardpointe-system-constants';
import { CloverIpgSystemId } from './clover/clover-system-constants';
import {
    CardDetailsModel,
    type IpgCardDetailsModelPolicy,
    type IpgCardDetailsModelResolution,
} from './ipg-card-details-model.types';
import { ValorIpgSystemId } from './valor/valor-system-constants';

export const VALOR_CARD_DETAILS_MODEL_POLICY = {
    capable_models: [CardDetailsModel.FULLY_OWNED],
    enabled_models: [CardDetailsModel.FULLY_OWNED],
    default_model: CardDetailsModel.FULLY_OWNED,
} as const satisfies IpgCardDetailsModelPolicy;

export const CARDPOINTE_CARD_DETAILS_MODEL_POLICY = {
    capable_models: [CardDetailsModel.FULLY_OWNED, CardDetailsModel.HOSTED_IFRAME],
    enabled_models: [CardDetailsModel.HOSTED_IFRAME],
    default_model: CardDetailsModel.HOSTED_IFRAME,
} as const satisfies IpgCardDetailsModelPolicy;

export const CLOVER_CARD_DETAILS_MODEL_POLICY = {
    capable_models: [CardDetailsModel.FULLY_OWNED, CardDetailsModel.HOSTED_FIELDS],
    enabled_models: [CardDetailsModel.HOSTED_FIELDS],
    default_model: CardDetailsModel.HOSTED_FIELDS,
} as const satisfies IpgCardDetailsModelPolicy;

export const IPG_CARD_DETAILS_MODEL_POLICIES: Readonly<
    Record<IpgSystemId, IpgCardDetailsModelPolicy>
> = {
    [ValorIpgSystemId]: VALOR_CARD_DETAILS_MODEL_POLICY,
    [CardPointeIpgSystemId]: CARDPOINTE_CARD_DETAILS_MODEL_POLICY,
    [CloverIpgSystemId]: CLOVER_CARD_DETAILS_MODEL_POLICY,
};

export const resolveDefaultCardDetailsModel = (ipgSystemId: IpgSystemId): CardDetailsModel =>
    IPG_CARD_DETAILS_MODEL_POLICIES[ipgSystemId].default_model;

export function resolveIpgCardDetailsModel(
    ipgSystemId: IpgSystemId,
    selectedModel?: CardDetailsModel
): IpgCardDetailsModelResolution {
    const model = selectedModel ?? resolveDefaultCardDetailsModel(ipgSystemId);
    const policy = IPG_CARD_DETAILS_MODEL_POLICIES[ipgSystemId];
    const providerName = IpgSystemIdToName[ipgSystemId];
    if (!policy.capable_models.includes(model)) {
        return {
            success: false,
            model,
            reason: 'unsupported',
            message: `${model} card entry is not supported by ${providerName}`,
        };
    }
    if (!policy.enabled_models.includes(model)) {
        return {
            success: false,
            model,
            reason: 'disabled',
            message: `${model} card entry is not currently enabled for ${providerName}`,
        };
    }
    return { success: true, model };
}
